module.exports = __webpack_public_path__ + "static/img/cup_red.1c7a6480.png";